import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const CapSegmentRemainder = (props) => {
  const { capAmount, capSegments, capSegmentRemainder, updateCapSegmentRemainder } = props;
  if (!capSegments || capSegments.length === 0) return null;
  const sumSegmentAmounts = capSegments.reduce((acc, cur) => {
    if (cur.segmentAmount > 0) {
      return acc + cur.segmentAmount;
    } else {
      return acc;
    }
  }, 0);

  const remainder = capAmount - sumSegmentAmounts;
  const percentageLeft = ((remainder / capAmount) * 100).toFixed(0);

  // Check if there is a difference between remainder and capSegmentRemainder
  if (remainder !== capSegmentRemainder) {
    // Set capSegmentRemainder to the new remainder
    updateCapSegmentRemainder(remainder);
  }

  // A read-out, not a control: it was a disabled Button carrying hardcoded greys.
  return (
    <Box
      sx={{
        width: '100%',
        px: 2,
        py: 1,
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'action.selected',
      }}
    >
      <Typography component='span'>{remainder}</Typography>{' '}
      <Typography component='span' variant='caption' color='text.secondary'>
        ({percentageLeft}%)
      </Typography>
    </Box>
  );
};

export default CapSegmentRemainder;
